import styled from "styled-components";
import Color from "./../../assets/color";

const HomeStyle = styled.div`
  .home-title {
    font-family: "Lato Black", sans-serif;
    font-size: 30px;
    margin-bottom: 2rem;
  }
  .bg-athensGrey {
    background: ${Color.athensGrey};
  }
  .p-section {
    padding: 5rem 0;

    @media (max-width: 768px) {
      padding: 2rem 0;
    }
  }
  .see-more {
    font-size: 18px;
    font-weight: bold;
    float: left;
  }

  a.see-more {
    :hover {
      i {
        text-decoration: unset;
      }
    }
  }
  @media (max-width: 768px) {
    h1.home-title {
      font-size: 25px;
    }
    h3 {
      font-size: 20px;
    }
  }
  /*===== Home Banner Slider =====*/
  #section-home-banner {
    position: relative;
    padding-top: calc(100% * (479 / 1400));

    /* Custom Banner Size */
    // @media (max-width: 767px) and (orientation: portrait) {
    //   padding-top: 85%;
    // }

    .banner-container {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
    .slick-slider {
      height: 100%;
      div {
        height: 100%;
      }
      .slide-layer {
        position: relative;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;

        /* Delivery */
        &.delivery {
          background-image: url(${require("../../assets/img/home_banner/delivery/background.png")});

          .light {
            position: absolute;
            width: 53.8vw;
            top: 0;
            left: 3.2vw;
          }

          .phone {
            position: absolute;
            width: 30.3vw;
            bottom: 0vw;
            left: 14.2vw;
          }

          .rider {
            position: absolute;
            width: 17.9vw;
            bottom: 0.7vw;
            left: 40.2vw;
          }

          .e-voucher {
            position: absolute;
            width: 6.9vw;
            top: 2.4vw;
            left: 2vw;
          }

          .transport-ticket {
            position: absolute;
            width: 9.2vw;
            top: 11.7vw;
            left: 5.65vw;
          }

          .ordering {
            position: absolute;
            width: 10.55vw;
            top: 22.6vw;
            left: 2.6vw;
          }

          .snp {
            position: absolute;
            width: 6.9vw;
            top: 2vw;
            left: 44.6vw;
          }

          .prepaid-reload {
            position: absolute;
            width: 8.9vw;
            top: 9.7vw;
            left: 51.6vw;
          }

          .lolol-delivery {
            position: absolute;
            width: 9.7vw;
            top: 14.1vw;
            left: 62.4vw;
          }

          .postpaid-bill {
            position: absolute;
            width: 7.8vw;
            top: 21.7vw;
            left: 73.4vw;
          }

          .mall {
            position: absolute;
            width: 7.5vw;
            top: 25.5vw;
            left: 62.1vw;
          }

          .logo {
            position: absolute;
            width: 13.36vw;
            top: 2vw;
            right: 5.4vw;
            animation-delay: 0.5s;
          }

          .download-ios {
            position: absolute;
            width: 5.5vw;
            top: 16.2vw;
            right: 12.3vw;
            animation-delay: 1.5s;
            animation-duration: 2s;
            img {
              width: 100%;
            }
          }
          .download-android {
            position: absolute;
            width: 5.5vw;
            top: 16.2vw;
            right: 6.3vw;
            animation-delay: 2.3s;
            animation-duration: 2s;
            img {
              width: 100%;
            }
          }

          @media (max-width: 767px) and (orientation: portrait) {
            background-size: auto 100%;
            background-position: right top;

            .light,
            .e-voucher,
            .transport-ticket,
            .ordering,
            .snp,
            .prepaid-reload,
            .lolol-delivery,
            .postpaid-bill,
            .mall,
            .logo {
              display: none;
            }

            .phone {
              position: absolute;
              width: 64vw;
              bottom: 5vw;
              left: 4vw;
            }

            .rider {
              position: absolute;
              width: 34vw;
              bottom: 6vw;
              left: 59vw;
            }

            .download-ios {
              position: absolute;
              width: 26.5vw;
              top: 9vw;
              right: 4vw;
              animation-delay: 1s;
            }
            .download-android {
              position: absolute;
              width: 26.5vw;
              top: 18vw;
              right: 4vw;
              animation-delay: 1.8s;
            }
          }

          @media (max-width: 767px) and (orientation: landscape) {
            .logo {
              display: none;
            }
            .download-ios {
              position: absolute;
              width: 18vw;
              top: 3vw;
              right: 3vw;
              animation-delay: 1s;
            }
            .download-android {
              position: absolute;
              width: 18vw;
              top: 10vw;
              right: 3vw;
              animation-delay: 1.8s;
            }
          }
        }
        /* END Delivery */

        /* Food Delivery */
        &.food-delivery {
          height: 100%;
          background-image: url(${require("../../assets/img/home_banner/food-delivery/background.jpg")});

          .download-ios {
            position: absolute;
            width: 12.6vw;
            top: 23.5vw;
            left: 53.1%;
            animation-delay: 0.5s;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .download-android {
            position: absolute;
            width: 12.6vw;
            top: 23.5vw;
            left: 66.9%;
            animation-delay: 1s;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        /* END Food Delivery */
      }
    }
  }
  /*===== END Home Banner Slider =====*/
  /*===== Select Location =====*/
  .select-location {
    color: white;
    font-family: "Lato Bold", sans-serif;
    font-size: 18px;
    padding: 10px 0;

    .location {
      width: fit-content;
      :hover {
        cursor: pointer;
      }
    }
  }
  /*===== END Select Location =====*/
  /*===== Restaurant & Mall Buttons =====*/
  .container-restaurant-mall-button {
    background: ${Color.athensGrey};
    padding-top: 11rem;
    padding-bottom: 10rem;

    .buttons-container {
      display: flex;

      @media (max-width: 767px) {
        flex: wrap;
      }
    }

    @media (max-width: 991px) {
      padding-top: 7rem;
      padding-bottom: 3rem;
    }

    @media (max-width: 767px) {
      .column-mall {
        margin-top: 6rem;
      }
    }

    @media (max-width: 575px) {
      .col-12 + .col-12 {
        margin-top: 6rem;
      }
    }

    .inner-container {
      background: ${Color.white};
      border-radius: 2rem;
      text-align: center;
      padding: 2rem;
      height: 100%;
      cursor: pointer;
      display: block;

      :hover {
        transform: scale(1.02);
      }

      .icon {
        width: 50%;
        margin-top: -8rem;
      }
      h3 {
        font-size: 24px;
        font-weight: 700;
        color: ${Color.black};
      }
      p {
        text-align: center;
        color: ${Color.black};
      }
    }
  }
  /*===== END Restaurant & Mall Buttons =====*/
  /*===== OUR SERVICES =====*/
  .our-services {
    .contain {
      .box {
        border-radius: 15px;
        padding: 10px;
        :hover {
          transform: scale(1.02);
          cursor: pointer;
          .coming-soon {
            opacity: 1;
          }
        }
        .image-wrapper {
          img {
            width: 100%;
            height: 100%;
          }
        }
        .coming-soon {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba(85, 85, 85, 0.8);
          border-radius: 15px;
          opacity: 0;
          transition: 0.5s ease;

          p.text {
            color: ${Color.white};
            font-size: 27px;
            font-family: "Lato Italic", sans-serif;
          }
        }
      }
      .name {
        p {
          font-family: "Lato Black", sans-serif;
        }
      }
    }
  }

  @media (min-width: 1028px) {
    .our-services {
      .contain {
        .box {
          height: 340px;
        }
        .name {
          p {
            font-size: 20px;
          }
        }
      }
    }
  }
  @media (max-width: 768px) {
    .our-services {
      .contain {
        .box {
          &.bg-athensGrey {
            background: none;
          }
          .image-wrapper {
            img {
              width: 80%;
              height: 80%;
            }
          }
        }
        .name {
          p {
            font-size: 13px;
          }
        }
      }
    }
  }
  /*===== END OUR SERVICES =====*/
  /*===== OUR PARTNER =====*/
  .our-partner {
    .slick-dots {
      position: relative;
      bottom: -25px;
    }
    .contain {
      display: flex;
      flex-direction: column;
      .square-box {
        background: ${Color.athensGrey};
        border-radius: 10px;
        margin: 2px;
        padding: 0.5em;
        height: 100%;
        .item {
          img {
            width: 30px;
            height: 30px;
          }
        }
        .label {
          font-weight: bold;
          p {
            margin: 0;
            font-size: 14px;
          }
        }
      }
    }
  }
  .our-partner
    > .container
    > .slick-slider
    > .slick-list
    > .slick-track
    > .slick-slide
    > div {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }
  @media (min-width: 1028px) {
    .our-partner {
      .contain {
        cursor: pointer;
        .square-box {
          padding: 1rem;
          margin: 5px;
          .item {
            img {
              width: 80px;
              height: 80px;
            }
          }
        }
      }
    }
  }
  @media (max-width: 768px) {
    .our-partner {
      .contain {
        .square-box {
          .label {
            p {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  /*===== END OUR PARTNER =====*/
  /*===== SPECIAL OFFER =====*/
  .special-offer
    > .container
    > .row
    > .col
    > div
    > .slick-slider
    > .slick-list
    > .slick-track
    > .slick-slide
    > div {
    margin-right: 5px;
  }
  .special-offer .slick-slider .slick-track {
    margin-left: 0;
    margin-right: 0;
    display: flex;

    .slick-slide {
      height: auto;

      > div {
        height: 100%;

        .voucher-comp {
          height: 100%;
        }
      }
    }
  }

  /*===== END SPECIAL OFFER =====*/
  /*=====  RECOMMENDED RESTAURANT =====*/
  .recommeded-restaurant {
    a.see-more {
      :hover {
        i {
          font-famiy: "Lato Regular", sans-serif;
        }
      }
    }
  }
  /*=====  END RECOMMENDED RESTAURANT =====*/
`;

export default HomeStyle;
